import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {};

const enhance = compose();

const tableHead = enhance(({ order, orderBy, onRequestSort }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell sortDirection={orderBy === 'userId' ? order : false}>
          <TableSortLabel
            active={orderBy === 'userId'}
            direction={order}
            onClick={() => {
              onRequestSort('userId');
            }}
          >
            ユーザID
          </TableSortLabel>
        </TableCell>
        <TableCell>ユーザ名</TableCell>
        <TableCell>メールアドレス</TableCell>
        <TableCell>生活困窮者登録</TableCell>
        <TableCell>更新日時</TableCell>
        <TableCell>こども申請日(最遅)</TableCell>
        <TableCell>困窮者審査状況</TableCell>
        <TableCell>生年月日審査状況 - 人数</TableCell>
        <TableCell />
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(tableHead);
